import React from "react";
import { whatsappNumber, whatsappMessage } from "../../data/siteData";
import "./FloatingWhatsApp.css";

function FloatingWhatsApp() {
  const link = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    whatsappMessage
  )}`;

  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="floating-whatsapp"
    >
      💬
    </a>
  );
}

export default FloatingWhatsApp;